const IosSafeRegion = {
    SAFE_REGION_IPAD_PRO: 20,
    SAFE_REGION_IPHONEX: 34,
    SAFE_REGION_IPHONEX_NOPORTRIT: 21,
};

const IosToolBarSafeRegion = {
    TOOLBAR_SAFE_REGION_IPAD_PRO: 64,
    TOOLBAR_SAFE_REGION_IPHONEX: 78,
    TOOLBAR_SAFE_REGION_IPHONEX_NOPORTRIT: 65,
};

const BrowserListM = {
    BROWSER_LISR_M_HEIGHT_EDIRMODE: 90,
};

export { IosSafeRegion, IosToolBarSafeRegion, BrowserListM };
